import React from 'react';
import {Card, Col, Row} from 'reactstrap';
import Button from 'components/button';
import {useContactsForm} from './use-contacts-form';
import BodySection from './body-section';
import HeaderSection from './header-section';
import AppBarActions from 'components/VerticalLayout/app-bar-actions';
import Icon from '@ailibs/feather-react-ts';
import {useTranslation} from 'react-i18next';
import {FileText} from 'react-feather';
import ExportsSection from '../../shared/exports-section';
import Can from 'features/hylian-shield/can';
import ListSkeleton from 'features/table/compenents/list-skeleton';

const Contacts = () => {
  const {t} = useTranslation();
  const form = useContactsForm();

  if(form.isLoadingContacts) return <ListSkeleton />

  return (
    <Card>
      <HeaderSection {...form} />
      <BodySection {...form} />
      <Row>
        <Col md={8}>
          <div className="justify-content-end d-flex">
            <AppBarActions>
              <>
                <Can action="edit" subject={form.subject}>
                  <Button
                    isLoading={form.isLoading}
                    onClick={form.submit}
                    color="important"
                  >
                    <Icon name="check" size={15} className="me-1" />
                    {t('common.saveChanges')}
                  </Button>
                </Can>
                <ExportsSection />
              </>
            </AppBarActions>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default Contacts;
